import useUserDetails from "hooks/useUserDetails";
import Dropdown from "component/form/dropDown";
import Modal from "react-bootstrap/Modal";
import currencyPairCheck from "utilities/currencyPairCheck";
import { formatMoney } from "utilities/formatMoney";
import { currencies } from "constants/currency";
import { GenericBtn } from "pages/finance/v2/FinanceRequest";
import { currencyToDisplay, formatDate } from "../../utils";
import { InvoiceIcon } from "asset/icons";
import PurchaseInvoiceSelect from "../../shipments/components/modals/PurchaseInvoiceSelect";
import PurchaseOrdersSelect from "../../shipments/components/PurchaseOrderSelect";
import { Trash } from "iconsax-reactjs";
import { Button } from "component/ui/Button";
import { useEffect, useState } from "react";
import FileUploader from "component/finance/FIleUploader";
import UploadDocModal from "component/form/uploadDocModal";
import { handleUploadFileUtils } from "api/fetchers";
import { useMutation } from "react-query";
import { cn } from "lib/utils";
import {
    displayCurrencyAndAmount,
    fileTypeToUpload,
    PaymentOptions,
} from "constants/FinanceConstants";
import { toast } from "react-toastify";
import { InputNumberFormat, unformat } from "@react-input/number-format";

const AddPODocs = "Add_Po_Docs";
const AddInvoiceDocs = "Add_Invoice_Docs";

const MakePayModal = ({
    show,
    setShow,
    isLoading,
    onClick,
    currency,
    walletBalance,
    amount,
    setAmount,
    maxAmount,
    isRepayment = false,
    setPaymentType,
    paymentType,
    isFinance = false,
    setPaymentMethod,
    paymentMethod,
    selectedInvoice,
    setSelectedInvoice,
    transactionDocument,
    setTransactionDocument,
    freightDocument,
    setFreightDocument,
    payFull,
    setPayFull,
    setInvoiceUrl,
    invoiceUrl,
    purchaseOrderUrl,
    setPurchaseOrderUrl,
    payFullAmount,
  showFullAmountToggle = true,
  otherDocument: propOtherDocument,
  setOtherDocument: propSetOtherDocument,
  reason: propReason,
  setReason: propSetReason,
  defaultState
}) => {
    const closeModal = () => {
        setPaymentMethod?.("");
        setSelectedInvoice?.(null);
        setTransactionDocument?.(null);
      setFreightDocument?.(null);
      propSetOtherDocument?.(null);
      propSetReason?.("");
        setShow(!show);
        setAmount("");
      setPaymentType?.('');
      defaultState?.()
    };
  const { isLoadingCreditWallet, isLoadingCreditBalance, creditWalletBalance, walletCurrency, transferFeesData, isLoadingTransferFees } =
    useUserDetails({ enableTransferFees: Boolean(show), amount });
    const [manual, setManual] = useState(false);
  const [addDocModal, setAddDocModal] = useState(null);
  const [localReason, setLocalReason] = useState("");
  const reason = propReason !== undefined ? propReason : localReason;
  const setReason = propSetReason !== undefined ? propSetReason : setLocalReason;

  const [localOtherDocument, setLocalOtherDocument] = useState(null);
  const otherDocument = propOtherDocument !== undefined ? propOtherDocument : localOtherDocument;
  const setOtherDocument = propSetOtherDocument !== undefined ? propSetOtherDocument : setLocalOtherDocument;
  const amountIsValid = amount?.length && Number(unformat(amount)) <= walletBalance;
    const isPOorInvoice =
        paymentMethod === PaymentOptions[0] || paymentMethod === PaymentOptions[1];
    const isFinanceDisabled = isPOorInvoice
        ? amountIsValid && !!paymentMethod && !!selectedInvoice
      : paymentMethod === PaymentOptions[4]
        ? amountIsValid && !!paymentMethod
        : amountIsValid && !!paymentMethod && (!!transactionDocument || !!freightDocument);
    const validationToUse = manual
        ? amountIsValid && (!!purchaseOrderUrl || !!invoiceUrl)
        : isFinanceDisabled;
  const isDisabled = Number(unformat(amount)) > walletBalance || Number(unformat(amount)) < 1;
  const isRepaymentDisabled = !!paymentType && (Number(unformat(amount)) < 1 || Number(unformat(amount)) < walletBalance ||
    Number(unformat(amount)) < creditWalletBalance ||
    Number(unformat(amount)) < walletBalance + creditWalletBalance);
    const btnText = isLoading ? "Loading..." : amount ? `Make payment` : "Pay";
    const handleDelete = (id) => {
        setSelectedInvoice(null);
    };
    const { mutateAsync: uploadDocumentFunc, isLoading: uploadingDocsLoading } = useMutation({
        mutationFn: ({ selectedFile, name }) => {
            return handleUploadFileUtils({ selectedFile, name });
        },
        onError: (error) => {
            console.log({ error });
        },
    });
    useEffect(() => {
        if (paymentMethod !== "Purchase order") {
            setManual(false);
        }
    }, [paymentMethod]);
    const addFilesToState = (fileType, response) => {
        switch (fileType) {
            case fileTypeToUpload.Freight:
                return setFreightDocument(response);
            case fileTypeToUpload.Transaction:
                return setTransactionDocument(response);
          case fileTypeToUpload.Other:
            return setOtherDocument(response);
            case AddPODocs:
                return setPurchaseOrderUrl(response);
            case AddInvoiceDocs:
                return setInvoiceUrl(response);
            default:
                return undefined;
        }
    };

    const paymentTypeOptions =
        !isLoadingCreditBalance || !isLoadingCreditWallet
            ? [
                  {
                      label: `Credit Wallet - ${displayCurrencyAndAmount(
                          walletCurrency,
                          creditWalletBalance
                      )}`,
                      value: "Credit Wallet",
                  },
                  {
                      label: `${currencyPairCheck(walletCurrency, { returnType: "name" })} Wallet - ${displayCurrencyAndAmount(
                          walletCurrency,
                          walletBalance
                      )}`,
                      value: "Naira Wallet",
                  },
                  { label: "Use both wallets", value: "both" },
              ]
            : [];

    useEffect(() => {
        setAmount?.(payFull ? payFullAmount : maxAmount);
    }, [payFull, payFullAmount, maxAmount, setAmount]);

    const amountUnpaidForPoOrInvoice = selectedInvoice?.totalAmount - selectedInvoice?.paidAmount;
  const isValidAmountToBePaid = Number(unformat(amount)) > amountUnpaidForPoOrInvoice;
    const isAmountMoreThanBalance = isFinance
      ? Number(unformat(amount)) + 100 > creditWalletBalance
      : Number(unformat(amount)) + 100 > walletBalance;
  const isAmountInvalid = isValidAmountToBePaid || isAmountMoreThanBalance;

    return (
        <Modal
            show={show}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            className="border-0 "
            onHide={closeModal}
        >
            <Modal.Body
                style={{
                    borderRadius: "16px",
                    padding: "0px",
                    border: "none",
                }}
                className="bg-white rounded-md"
            >
                {" "}
                <div className="w-full gap-4 px-4 py-4 ">
                    <div className="flex items-center justify-between">
                        <h5 className="text-xl font-semibold text-gray-90">
                            Make a {isRepayment ? "repayment" : "payment"}
                        </h5>

                        <span
                            className="cursor-pointer material-icons"
                            style={{ color: "#667085" }}
                            onClick={closeModal}
                        >
                            close
                        </span>
                    </div>
                    {isFinance ? (
                        <p className="text-base font-normal text-gray-50">
                            Request payment for active invoices, orders and transactions
                        </p>
                    ) : isRepayment ? (
                        <p className="text-base font-normal text-gray-50">
                            Trigger a repayment for this loan{" "}
                        </p>
                    ) : (
                        <p className="text-base font-normal text-gray-50">
                            Pay for this invoice from your Tradevu wallet
                        </p>
                    )}

                    {isFinance ? (
              <div className="flex flex-col gap-3">
                            <Dropdown
                                value={paymentMethod}
                  options={PaymentOptions.map((option) => ({
                                    label: (
                                        <p className="flex items-center justify-between w-full">
                                            <span>{option} </span>
                                            {option === "Transaction" && (
                                                <span className="ml-auto text-right text-[#6F739B]">
                                                    e.g. bill of lading
                                                </span>
                                            )}
                                            {option === "Freight" && (
                                                <span className="ml-auto text-right text-[#6F739B]">
                                                    e.g. waybill
                                                </span>
                                            )}
                                        </p>
                                    ),
                                    value: option,
                                }))}
                                onChange={(value) => setPaymentMethod(value)}
                                label="What is this payment for?"
                                labelClassName="mb-1 text-sm text-gray-70 font-normal"
                                inputBg="#EFF0FA"
                                placeholder="Select option"
                />
                {paymentMethod === PaymentOptions[4] && (
                  <textarea
                    className="rounded-lg placeholder:text-[15px] placeholder:text-sm placeholder:text-[#6F739B]/90 placeholder:font-normal resize-none h-[96px] w-full p-3 bg-[#EFF0FA]"
                    placeholder="Please specify"
                    value={reason}
                    onChange={(evt) => setReason(evt.target.value)}
                  />
                )}
                            {paymentMethod === PaymentOptions[2] && (
                                <FileUploader
                                    title="Transaction document"
                                    forFinance={true}
                                    showSample={true}
                                    file={transactionDocument}
                                    setFile={setTransactionDocument}
                                    details={
                                        "Upload relevant transaction document e.g. bill of lading"
                                    }
                                    noModal
                                    onChange={async (selectedFile, name) => {
                                        try {
                                            const response = await uploadDocumentFunc({
                                                selectedFile,
                                                name,
                                            });
                                          if (response?.statusCode !== 400) {
                                                const file = {
                                                    size: selectedFile?.size,
                                                    name,
                                                    url: response?.link,
                                                };
                                                addFilesToState(fileTypeToUpload.Transaction, file);
                                            } else {
                                                toast.error(
                                                    response?.message || "Error uploading file"
                                                );
                                            }
                                        } catch (error) {
                                            console.log({ error }, "error");
                                        }
                                    }}
                                />
                            )}

                            {paymentMethod === PaymentOptions[3] && (
                                <FileUploader
                                    title="Freight document"
                                    forFinance={true}
                                    showSample={true}
                                    file={freightDocument}
                                    setFile={setFreightDocument}
                                    details={"Upload relevant freight document e.g. waybill"}
                                    noModal
                                    onChange={async (selectedFile, name) => {
                                        try {
                                            const response = await uploadDocumentFunc({
                                                selectedFile,
                                                name,
                                            });
                                          if (response?.statusCode !== 400) {
                                                const file = {
                                                    size: selectedFile?.size,
                                                    name,
                                                    url: response?.link,
                                                };
                                                addFilesToState(fileTypeToUpload.Freight, file);
                                            } else {
                                                toast.error(
                                                    response?.message || "Error uploading file"
                                                );
                                            }
                                        } catch (error) {
                                            console.log({ error }, "error");
                                        }
                                    }}
                                />
                            )}
                            {(paymentMethod === PaymentOptions[0] ||
                                paymentMethod === PaymentOptions[1]) && (
                                <div className="">
                                    {manual
                                        ? null
                                        : !selectedInvoice && (
                                              <label className="mb-1 text-sm text-gray-70">
                                                  {paymentMethod === PaymentOptions[0]
                                                      ? "What invoice is this for"
                                                      : "Select a purchase order"}
                                              </label>
                                          )}
                                    {selectedInvoice ? (
                                        <div className="flex items-center gap-x-2">
                                            <div className="flex justify-between w-full py-3 mb-2 bg-white rounded-lg">
                                                <div className="flex items-center gap-x-2">
                                                    <div className="flex items-center justify-center flex-shrink-0 p-2 bg-purple-100 rounded-full">
                                                        <InvoiceIcon className="size-4" />
                                                    </div>
                                                    <div className="flex flex-col">
                                                        <p className="">
                                                            {selectedInvoice?.merchant}
                                                        </p>
                                                        <div className="flex items-start flex-col text-xs gap-1 text-[14px] ">
                                                            <p className="flex items-center w-11/12 text-base flex-nowrap whitespace-nowrap">
                                                                <span>
                                                                    {selectedInvoice?.title}
                                                                </span>
                                                                <span>•</span>
                                                                <span className="truncate">
                                                                    {
                                                                        selectedInvoice?.outbound
                                                                            ?.businessName
                                                                    }
                                                                </span>
                                                            </p>
                                                            <p className="text-left text-[#6B7280]">
                                  Unpaid <span>•</span>{" "}
                                  {currencyToDisplay(currency,
                                                                    amountUnpaidForPoOrInvoice
                                                                )}
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="flex flex-col">
                                                    <p className="text-right text-">
                                                        {selectedInvoice?.totalAmount
                                ? `${currencyToDisplay(currency,
                                  selectedInvoice?.totalAmount
                                                              )}`
                                                            : "--"}
                                                    </p>
                                                    <div className="text-right text-xs text-[#6B7280]">
                                                        {formatDate(selectedInvoice?.createdAt)}
                                                    </div>
                                                </div>
                                            </div>

                                            <Trash
                                                size={18}
                                                className="pointer"
                                                onClick={() => handleDelete(selectedInvoice?._id)}
                                            />
                                        </div>
                                    ) : (
                                        <>
                                            {manual &&
                                            (paymentMethod === PaymentOptions[0] ||
                                                paymentMethod === PaymentOptions[1]) ? (
                                                <FileUploader
                                                    showSample={true}
                                                    title={
                                                        paymentMethod === PaymentOptions[0]
                                                            ? "Upload Invoice order"
                                                            : "Upload Purchase order"
                                                    }
                                                    file={
                                                        paymentMethod === PaymentOptions[0]
                                                            ? invoiceUrl
                                                            : purchaseOrderUrl
                                                    }
                                                    forFinance
                                                    noModal
                                                    onChange={async (selectedFile, name) => {
                                                        try {
                                                            const response =
                                                                await uploadDocumentFunc({
                                                                    selectedFile,
                                                                    name,
                                                                });
                                                          if (response?.statusCode !== 400) {
                                                                const file = {
                                                                    size: selectedFile?.size,
                                                                    name,
                                                                    url: response?.link,
                                                                };
                                                                addFilesToState(
                                                                    paymentMethod ===
                                                                        PaymentOptions[0]
                                                                        ? AddInvoiceDocs
                                                                        : AddPODocs,
                                                                    file
                                                                );
                                                            } else {
                                                                toast.error(
                                                                    response?.message ||
                                                                        "Error uploading file"
                                                                );
                                                            }
                                                        } catch (error) {
                                                            console.log({ error }, "error");
                                                        }
                                                    }}
                                                />
                                            ) : paymentMethod === PaymentOptions[0] ? (
                                                <PurchaseInvoiceSelect
                                                    setOrderDimensionsList={setSelectedInvoice}
                                                    forFinance={true}
                                                    forRepayment={true}
                                                />
                                            ) : (
                                                <PurchaseOrdersSelect
                                                    setOrderDimensionsList={setSelectedInvoice}
                                                    forFinance
                                                    forRepayment={true}
                                                />
                                            )}
                                        </>
                                    )}
                                    {!selectedInvoice &&
                                        (paymentMethod === PaymentOptions[1] ||
                                            paymentMethod === PaymentOptions[0]) && (
                                            <Button
                                                variant="ghost"
                                                size="sm"
                                                className="!text-secondary p-0 font-light"
                                                onClick={() => setManual((prev) => !prev)}
                                            >
                                                {!manual
                                                    ? "Upload Manually"
                                                    : paymentMethod === PaymentOptions[0]
                                                    ? "Use Tradevu invoice order"
                                                    : "Use Tradevu Purchase order"}
                                            </Button>
                                        )}
                                </div>
                            )}
                            <div>
                                <div className="flex !gap-2 items-end">
                                    <div className="w-[125px]">
                                        <Dropdown
                                            value={currency}
                                            onChange={() => {}}
                                            options={currencies.map(({ title }) => ({
                                                label: title,
                                                value: title,
                                            }))}
                                            label="Amount to pay"
                                            labelClassName="!text-[#475467] truncate font-normal !mt-0 text-sm text-gray-70"
                                            placeholder="NGN"
                                            readOnly
                                            inputBg="#EFF0FA"
                                        />
                                    </div>

                                    <div className="w-full">
                      <InputNumberFormat
                                            required={true}
                                            placeholder={`Max: ${formatMoney(
                                                amountUnpaidForPoOrInvoice
                                            )}`}
                                            className={cn(
                                                "h-[56px] !pl-2 w-full placeholder:font-light placeholder:text-sm placeholder:text-main-grey  rounded-lg",
                                                isAmountInvalid
                                                    ? "bg-danger-40 !shadow-[inset_0_0_0_1000px_#FFE1E1]"
                                                    : "bg-[#EFF0FA] !shadow-[inset_0_0_0_1000px_#EFF0FA]"
                                            )}
                                            min="1"
                                            max={`${amountUnpaidForPoOrInvoice}`}
                                            // formatType="integer"
                        // value={amount}
                                            onChange={(evt) => setAmount(evt.target.value)}
                        // type={"number"}
                                            step="0.1"
                                        />
                                    </div>
                                </div>
                                <div className="flex items-center justify-between">
                                    <p className="!pr-5 !mt-1 font-normal text-[13px] text-grey-70">
                                        Credit balance:
                                        <span className="ml-1">
                                            {currencyPairCheck(currency)}{" "}
                                            {formatMoney(creditWalletBalance)}
                                        </span>
                                    </p>
                                    {isAmountInvalid && (
                                        <p className="text-right font-normal text-[13px] text-danger-20">
                                            {isAmountMoreThanBalance
                                                ? "Insufficient funds"
                                                : isValidAmountToBePaid
                                                ? "This exceeds the total due on this " +
                                                  paymentMethod
                                                : ""}
                                        </p>
                                    )}
                                </div>
                            </div>
                        </div>
                    ) : (
                        <>
                            <div className="flex flex-col !gap-2 !mt-7">
                                <p className="text-sm font-[450] text-gray-70">
                                    {isRepayment ? "Amount to pay" : "Amount"}
                                </p>
                                <div
                                    className={cn(
                                        `flex items-center text-gray-90 text-base font-normal rounded-lg !pl-4 w-auto h-[56px]`,
                                        isRepayment
                                            ? "bg-[#EFF0FA]"
                                            : isAmountInvalid
                                            ? "bg-danger-40"
                                            : "bg-[#EFF0FA]"
                                    )}
                                >
                                    <span className="text-sm font-[350]">
                                        {currencyPairCheck(currency)}
                                    </span>
                      <InputNumberFormat
                                        required={true}
                                        placeholder={formatMoney(
                                            payFull ? payFullAmount : maxAmount
                                        )}
                                        className={cn(
                                            "!pl-2 w-full h-full !shadow-[inset_0_0_0_1000px_#EFF0FA] rounded-lg",
                                            isRepayment
                                                ? "bg-[#EFF0FA] !shadow-[inset_0_0_0_1000px_#EFF0FA]"
                                                : isAmountInvalid
                                                ? "bg-danger-40 !shadow-[inset_0_0_0_1000px_#FFE1E1]"
                                                : "bg-[#EFF0FA] !shadow-[inset_0_0_0_1000px_#EFF0FA]"
                                        )}
                                        max={payFull ? payFullAmount : maxAmount}
                                        min="1"
                                        formatType="integer"
                        // value={amount}
                                        onChange={(evt) => setAmount(evt.target.value)}
                        // type={"text"}
                                        step="0.1"
                                        defaultValue={payFull ? payFullAmount : maxAmount}
                                        disabled={isRepayment ? true : false}
                                    />
                                </div>
                                {!isRepayment && (
                                    <div className="flex items-center justify-between">
                                        <p className="!pl-5 font-normal text-[13px] text-grey-70">
                                            Wallet balance:
                                            <span className="ml-1">
                                                {currencyPairCheck(currency)}{" "}
                                                {formatMoney(walletBalance)}
                                            </span>
                                        </p>
                                        {isAmountInvalid && (
                                            <p className="text-sm text-right text-danger-20">
                                                Insufficient funds
                                            </p>
                                        )}
                                    </div>
                                )}

                                <div className="flex items-center justify-end">
                                        {showFullAmountToggle && isRepayment ? (
                                        <label
                                            htmlFor="payFull"
                                            className={cn(
                                                "flex items-center justify-end gap-1 text-sm font-normal text-end ",
                                                !payFull ? "text-gray-80" : "text-gray-70"
                                            )}
                                        >
                                            <input
                                                id="payFull"
                                                name="payFull"
                                                type="checkbox"
                                                value={payFull}
                                                onChange={(e) => setPayFull(e?.target?.checked)}
                                            />
                                            Pay full amount
                                        </label>
                                    ) : null}
                                </div>
                            </div>
                            {isRepayment ? (
                                <>
                                    <div className="">
                                        <Dropdown
                                            value={paymentType}
                                            options={paymentTypeOptions.map((option) => ({
                                                label: option.label,
                                                value: option.value,
                                            }))}
                                                onChange={(value) => setPaymentType?.(value)}
                                            label="Payment source"
                                            labelClassName="mb-1 text-sm text-gray-70 font-normal"
                                            inputBg="#EFF0FA"
                                            placeholder="Select an option"
                                        />
                                    </div>
                                    {paymentType === "both" && (
                                        <p className="!px-5 !mt-1 font-normal text-[13px] text-grey-70">
                                            Total balance:
                                            <span className="ml-1">
                                                {currencyPairCheck(currency)}{" "}
                                                {formatMoney(walletBalance + creditWalletBalance)}
                                            </span>
                                        </p>
                                    )}
                                </>
                            ) : null}
                        </>
                    )}
            {paymentMethod === PaymentOptions[4] && (
              <div className="mt-4">
                <FileUploader
                  title={
                    <span className="text-sm font-normal text-gray-70">
                      Supporting document <span className="font-light italic text-[#6F739B] ml-1.5">• Optional</span>
                    </span>
                  }
                  forFinance={true}
                  showSample={true}
                  file={otherDocument}
                  setFile={setOtherDocument}
                  noModal
                  uploadText="Upload document"
                  isLoading={uploadingDocsLoading}
                  onChange={async (selectedFile, name) => {
                    try {
                      const response = await uploadDocumentFunc({
                        selectedFile,
                        name,
                      });
                      if (response?.statusCode !== 400) {
                        const file = {
                          size: selectedFile?.size,
                          name,
                          url: response?.link,
                        };
                        addFilesToState(fileTypeToUpload.Other, file);
                      } else {
                        toast.error(
                          response?.message || "Error uploading file"
                        );
                      }
                    } catch (error) {
                      console.log({ error }, "error");
                    }
                  }}
                />
              </div>
            )}
                </div>
                <div
                    className={cn(
                        "flex items-center p-3 gap-x-5",
                        isFinance ? "justify-between" : "justify-end"
                    )}
                    style={{
                        borderTop: "1px solid #E7E9FB",
                    }}
                >
                    {isFinance ? (
                        <p className="text-sm font-light">
                            Transfer fee:{" "}
                            <span
                                className={cn(
                                    "font-medium",
                                    isAmountInvalid ? "text-danger-20" : ""
                                )}
                            >
                  {isLoadingTransferFees ? '--' : displayCurrencyAndAmount(currency, transferFeesData?.transactionFee || 0)}
                            </span>
                        </p>
                    ) : null}
                    {isFinance ? (
                        <GenericBtn
                            disabled={isLoading || !validationToUse || isAmountInvalid}
                            onClick={onClick}
                            text="Make Payment"
                        />
                    ) : isRepayment ? (
                        <GenericBtn
                            disabled={isLoading || !isRepaymentDisabled}
                            type="button"
                            onClick={onClick}
                            text={btnText}
                            className={"ml-auto"}
                        />
                    ) : (
                        <GenericBtn
                            disabled={isLoading || isDisabled}
                            type="button"
                            onClick={onClick}
                            text={btnText}
                            className={"ml-auto"}
                        />
                    )}
                </div>
                {addDocModal && (
                    <UploadDocModal
                        close={() => setAddDocModal(null)}
                        loading={uploadingDocsLoading}
                        uploadFunc={async (selectedFile, name) => {
                            const response = await uploadDocumentFunc({
                                selectedFile,
                                name,
                            });
                          if (response?.statusCode !== 400) {
                                const file = {
                                    size: selectedFile?.size,
                                    name,
                                    url: response?.link,
                                };
                                addFilesToState(addDocModal, file);
                                setAddDocModal(null);
                            }
                        }}
                    />
                )}
            </Modal.Body>
        </Modal>
    );
};

export default MakePayModal;
